"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMemberGameList = void 0;
const axios_1 = __importDefault(require("axios"));
/**
 * Returns a list of all games belonging to a member.
 * Member can be identified by either Discord ID or Steam ID, but at least one of those values **must** be provided.
 *
 * ### Filter options
 *
 * - `completionPercentage` - filters by EXACT completion percentage of the game by member,
 * - `isCurated` - filters by game's curation status.
 *
 * ### Sort options
 *
 * - `playTime` - sorts by member's play time of their games,
 * - `completionPercentage` - sorts by member's completion percentage of all their games,
 * - `tier` - sorts by member's games tier,
 * - `achievementsTotal` - sorts by number of achievements of the member's games.
 *
 * ## Usage
 *
 * ```ts
 * const steamId: string = "567876545678";
 *
 * const memberGames: MemberGame[] = await sdk.getMemberGameList({ steamId });
 * const memberGamesCompleted: MemberGame[] =
 *   await sdk.getMemberGameList({ steamId, filter: { completed: 100 }});
 * const memberGamesByAchievements: MemberGame[] =
 *   await sdk.getMemberGameList({ steamId, sort: { achievementsTotal: 'desc' }});
 * ```
 *
 * @param params.steamId   - (Optional) Steam ID of the requested member.
 * @param params.discordId - (Optional) Discord ID of the requested member.
 * @param params.filter - Filter to apply to returned member's game list.
 * @param params.sort - Fields to sort member's game list by.
 * @param params.limit - How many member's games will get returned.
 */
const getMemberGameList = (params, 
/** @ignore */
BASE_URL) => __awaiter(void 0, void 0, void 0, function* () {
    const { steamId, discordId, filter, sort, limit } = params;
    const memberId = steamId !== null && steamId !== void 0 ? steamId : discordId;
    const url = `${BASE_URL}/members/member/${memberId}/games/list`;
    const memberGameListResponse = yield axios_1.default.post(url, { filter, sort, limit }, { validateStatus: () => true });
    const { status, data } = memberGameListResponse;
    if (status !== 200)
        throw new Error(data.error);
    return data;
});
exports.getMemberGameList = getMemberGameList;
